import { projectResponseFields } from '../../common/response/project'
import { findEntityTitle, generateLocationData } from '../../utils/general'
import { AsyncSelectOption } from '../globalTypes'
import { ProjectItem } from './types'

export const formatProjectAsyncOption = (item: ProjectItem): AsyncSelectOption => ({
    value: item.id,
    label: `ID: ${item.internalAppId} - ${findEntityTitle(item, projectResponseFields.PROJECT_TITLE)}`,
    location: generateLocationData(item),
})
